<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-confirm-dialog-panel tenga la fascia panna a filo del bordo
     inferiore. -->
<h2 mat-dialog-title>Conferma della data</h2>

<mat-dialog-content>
  <p class="izy-confirm-message">
    Stai per inviare il documento con data
    <strong>{{ formattedDate }}</strong>, superiore a 12 giorni fa.
  </p>

  <p class="izy-confirm-question">Confermi?</p>

  <!-- La spunta obbligatoria in un riquadro a se', come nel dialog di conferma
       condiviso: e' il cancello del "Confermo", non una riga di testo in mezzo
       al messaggio. -->
  <div class="izy-confirm-box izy-sharp-bl">
    <mat-checkbox [(ngModel)]="confirmed" color="primary">
      <span class="fw-bold">Sì, la data è corretta</span>
    </mat-checkbox>
  </div>

  <!-- if invoice is healthcare -->
  <p class="izy-confirm-note">
    Nota: questo documento contiene una data incompatibile con l'emissione di
    Fattura elettronica. Pertanto, il documento può essere generato solo come
    fattura cartacea e non verrà inviato allo SDI.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="izy-dialog-actions">
  <button
    mat-stroked-button
    type="button"
    mat-dialog-close
    class="izy-button-ghost custom-button-border">
    <mat-icon>arrow_back</mat-icon>
    Torna indietro
  </button>

  <button
    mat-raised-button
    matButton="filled"
    type="button"
    class="ms-2 izy-button-primary custom-button-border"
    [disabled]="!confirmed"
    (click)="confirm()">
    <mat-icon>check</mat-icon>
    Confermo
  </button>
</mat-dialog-actions>
